import React  from "react";
import { useParams } from 'react-router-dom';
import EmployeeForm from "./components/EmployeeForm";
import AccountHeader from "../components/AccountHeader";

const EditEmployee = () => {
	const { accountId, employeeId } = useParams();

	return (
	    <div>
	      	<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<AccountHeader className="mt-5"/>
				<EmployeeForm recordId={employeeId} accountId={accountId} mode="edit"/>
			</div>
	    </div>
    );
};

export default EditEmployee;